import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { WorkOrderService, rgrnService } from "../../../services/index";
import { throwMatDuplicatedDrawerError } from "@angular/material";

@Component({
  selector: "ocr-print",
  templateUrl: "./ocrDcPrint.html",
})
export class ocrDcPrint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  @Input() partydata: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  designList: any = [];
  printdata: any = {};
  woGrTot : number = 0;
  woGrTotMtr : number = 0;
  wodata: any = {};
  dataList : any = [];
  woDetails : any;
  alphabet: string[];
  predefCol : number;
  userDefCol : number;
  cuttingRatio : number;
  woCons : number;
  maxColor : number;
  toDay : any;
  value: number;
  ftotal: number = 0;
  htotal: number = 0;
  wo_total: number = 0;
  ac_ftotal: number = 0;
  ac_htotal: number = 0;
  ac_total: number = 0;
  del_ftotal: number = 0;
  del_htotal: number = 0;
  del_total: number = 0;
  can_total: number = 0;
  dam_total: number = 0; 
  @Input() set printdt(val: any[]) {
    this.printdata = val;
    console.log(this.printdata);
    this.getDesignList(this.printdata.dc_no,this.printdata.dc_date);
  }

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    private rgrnService: rgrnService,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    public datePipe: DatePipe
  ) {}

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(dc_no,dc_date) {
    let params = {
      dc_no : dc_no,
      dc_date : dc_date,
    };
    let that = this;
    that.rgrnService.getOcrDcPrint(params).then((res: any) => {
      that.dataList = res.data;
      this.findsum(that.dataList); 
      that.dataList.forEach(element => {
        element.wo_cons = ((element.fab_mtr) / (element.wo_qty)).toPrecision(3);
        element.avg_cons = ((element.fab_mtr) / (element.ac_qty)).toPrecision(3);
        let wodate = element.wo_date.split('-');
        let deldate = element.del_date.split('-');
        let woDate = new Date(wodate[2], wodate[1] - 1, wodate[0]); 
        let delDate = new Date(deldate[2], deldate[1] - 1, deldate[0]);
        var Difference_In_Time = delDate.getTime() - woDate.getTime(); 
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);  
        element.age = Difference_In_Days;
      });
      let todate = new Date();
      this.toDay = todate.getDate() + '-' + (todate.getMonth() + 1) + '-' + todate.getFullYear();
    });
  }

findsum(data){    
  this.value=data    
  for(let j=0;j<data.length;j++){   
       this.ftotal+= this.value[j].ftot;
       this.htotal+= this.value[j].htot;
       this.wo_total+= this.value[j].wo_qty;
       this.ac_ftotal+= this.value[j].ac_ftot;
       this.ac_htotal+= this.value[j].ac_htot;
       this.ac_total+= this.value[j].ac_qty;
       this.del_ftotal+= this.value[j].del_ftot;
       this.del_htotal+= this.value[j].del_htot;
       this.del_total+= this.value[j].del_qty;
       this.can_total+= this.value[j].can_qty; 
       this.dam_total+= this.value[j].dam_qty;
  }  
} 
  print(div) {
    var content = document.getElementById(div).innerHTML;
    var mywindow = window.open("", "Print", "height=850,width=1000");
    mywindow.document.write(content);
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/ocrDc/ocrDcPrint.ts